
const initialState = {
	data: [],
	searchFilter: null,
	roomTypeFilter: [],
	assetTypeFilter: [],
	buildingFilter: null,
	floorFilter: null,
	roomFilter: null,
	isLoading: false,
	hasError: false,
	availableBuildings: [],
	availableFloors: [],
	availableRooms: [],

};

export function roomsPage(state = initialState, action) {
	switch (action.type) {
	case 'ROOMS_PAGE_BUILDINGS_AVAIL':
		return {
			...state,
			availableBuildings: action.value
		};
	case 'ROOMS_PAGE_FLOORS_AVAIL':
		return {
			...state,
			availableFloors: action.value
		};
	case 'ROOMS_PAGE_ROOMS_AVAIL':
		return {
			...state,
			availableRooms: action.value
		};
	case 'ROOMS_PAGE_BUILDING_FILTER':
		return {
			...state,
			buildingFilter: action.value
		};
	case 'ROOMS_PAGE_FLOOR_FILTER':
		return {
			...state,
			floorFilter: action.value
		};
	case 'ROOMS_PAGE_ROOM_FILTER':
		return {
			...state,
			roomFilter: action.value
		};
	case 'ROOMS_PAGE_SEARCH':
		return {
			...state,
			searchFilter: action.value
		};
	case 'ROOMS_PAGE_ROOMTYPE_SELECT':
		return {
			...state,
			roomTypeFilter: action.value
		};
	case 'ROOMS_PAGE_ASSETTYPE_SELECT':
		return {
			...state,
			assetTypeFilter: action.value
		};
	case 'ROOMS_LOADING' :
		return {
			...state,
			isLoading: action.isLoading
		};
	case 'ROOMS_ERROR':
		return {
			...state,
			hasError: action.hasError
		};
	case 'ROOMS_FETCH_SUCCESS':
		return {
			...state,
			data: action.data
		};
	case 'ROOMSALL_FETCH_SUCCESS':
		return {
			...state,
			data: action.data
		};
	default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/RoomsPageReducer.js